module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-152x152-bf6065b6904f88748198c3cb50a58292.png";